import { render, staticRenderFns } from "./FrameMenu.vue?vue&type=template&id=7091d3b1&scoped=true&"
import script from "./FrameMenu.vue?vue&type=script&lang=js&"
export * from "./FrameMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7091d3b1",
  null
  
)

export default component.exports